import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class CardFadeIn {
	constructor(el) {

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: "top bottom",
			}
		});

		tl.from( el, {
			opacity: 0.3,
			y: 40,
			ease: "power3.out",
			duration: 2,
		})
	}
}
